module.exports = __webpack_public_path__ + "img/x.e5c9cce9.svg";